import { Dayjs } from "dayjs";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { StyledButton } from "../../../../components/Button/button";
import { theme } from "../../../../helpers/theme";
import { useAppDispatch, useAppSelector } from "../../../../hooks/redux-hooks";
import { order } from "../../../../redux/actions";
import { ApplicationState } from "../../../../redux/reducers";
import AdditionalServicesPopover from "./additional-services-popover";
import DatePickers from "./date-pickers";
import LocationPopover from "./location-popover";
import StoragePopover from "./storage-popover";

const FormBar = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const orderStart = useAppSelector(
    (state: ApplicationState) => state.order.orderStart
  );
  const [element, setElement] = useState<string>(
    orderStart ? orderStart.miasto : ""
  );
  const [fromDate, setFromDate] = useState<Dayjs | null>(
    orderStart ? orderStart.termin_rozpoczecia : null
  );
  const [toDate, setToDate] = useState<Dayjs | null>(
    orderStart ? orderStart.termin_zakonczenia : null
  );
  const [dateFromError, setDateFromError] = useState<string | null>(null);
  const [dateToError, setDateToError] = useState<string | null>(null);
  const [storageElement, setStorageElement] = useState<string>(
    orderStart ? orderStart.uslugi_zamowione.cel_zamowienia : ""
  );
  const [additionalServices, setAdditionalServices] = useState<string[]>(
    orderStart ? orderStart.uslugi_zamowione.uslugi_dodatkowe : []
  );

  const isDisabled = useMemo(
    () =>
      element !== "" &&
        fromDate &&
        toDate &&
        !dateFromError &&
        !dateToError &&
        storageElement !== ""
        ? false
        : true,
    [element, fromDate, toDate, dateFromError, dateToError, storageElement]
  );
  const OrderInfos = useMemo(
    () => ({
      termin_rozpoczecia: fromDate,
      termin_zakonczenia: toDate,
      miasto: element,
      uslugi_zamowione: {
        cel_zamowienia: storageElement,
        uslugi_dodatkowe: additionalServices,
      },
    }),
    [element, fromDate, toDate, storageElement, additionalServices]
  );

  const handleClick = () => {
    dispatch(order.GetOrderStart(OrderInfos));
    navigate("/offer-form");
  };
  return (
    <>
      <FormBarDesktopContainer>
        <LocationPopover element={element} setElement={setElement} />
        <DatePickers
          fromDate={fromDate}
          setFromDate={setFromDate}
          toDate={toDate}
          setToDate={setToDate}
          setDateFromError={setDateFromError}
          setDateToError={setDateToError}
          OrderInfos={OrderInfos}
        />
        <StoragePopover
          storageElement={storageElement}
          setStorageElement={setStorageElement}
        />
        <AdditionalServicesPopover
          additionalServices={additionalServices}
          setAdditionalServices={setAdditionalServices}
        />
        <StyledButton
          variant="contained"
          disabled={isDisabled}
          sx={{
            width: "14%",
            height: "54px",
          }}
          onClick={handleClick}
        >
          Dalej
        </StyledButton>
      </FormBarDesktopContainer>
    </>
  );
};

export default FormBar;

const FormBarDesktopContainer = styled.div`
@media ${theme.device.Mlaptop} {
  display: none;
}
  width: 99%;
  margin-bottom: 150px;
  display: flex;
  background-color: white;
  height: 64px;
  align-items: center;
  border-radius: 16px;
  justify-content: space-between;
  padding 8px;
`;
